import ReactMounter from 'lib/ReactMounter'
import BerlinPage from 'pages/InvestmentLocations/BerlinPage/BerlinPage'

ReactMounter.registerComponentToMountOnLoad('BerlinPage', BerlinPage)
